import { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import arrowBack from '../../Shared/Images/atras-icon.png';
import VideoPlayer from '../VideoPlayer/VideoPlayer';


interface Props {
  isOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>; 
}

const ModalSeguimiento = ({isOpen, setIsOpen}: Props) => {

  // const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);


  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
      <DialogTitle sx={{ backgroundColor: 'white', fontWeight: '700'  }}>

        <div className='flex flex-row gap-3'>

          <img
            src={arrowBack}
            height={20}
            className="h-[20px] cursor-pointer self-start"
            onClick={() => setIsOpen(false) }
          />

          <p className='text-lg mb-0'> ¿Existe seguimiento 1 a 1? </p>

        </div>
      </DialogTitle>
      <DialogContent dividers className="flex flex-col justify-center items-center overflow-x-hidden">       

      {/* {!mostrarVideo ? (
        <div
          style={{
            position: 'relative',
          }}
          className="relative"
        >
          <ContainerButtonPlay
            onClick={() => {
              setMostrarVideo(true);
            }}
          >
            <img
              src={grayPlayButton}
              alt=""
              width={80}
              style={{ cursor: 'pointer' }}
            />
          </ContainerButtonPlay>

          <img 
            width={'100%'}
            height={'100%'}
            src={'https://bonostr4iner.s3.us-east-2.amazonaws.com/display_fit4_video_reemplaza_tus_alimentos_1.jpg'}
            alt="portada"
          />
        </div>
        ) : ( */}
          <VideoPlayer
            url={
              'https://player.vimeo.com/external/1005442958.m3u8?s=d0f525dabc0a7ebf05901bb8af076da5f1923e59&logging=false'
            }
          />
        {/* )} */}

        <a 
          className='no-underline hover:underline active:underline-offset-2 mt-3 text-base font-medium'
          href="https://wa.link/71loxz"
          target='_blank'
        >
          <WhatsAppIcon /> Quiero adquirir Método Tr4iner con seguimiento 1 a 1
        </a>

      </DialogContent>
    </Dialog>
  )
}

export default ModalSeguimiento;